<template>
    <section class="container-fluid">
        <div class="row mcas">
            <div class="col-md-6 col-lg-4 main">
                <div class="row" id="odrea">
                    <div class="col-12 m-record">
                        <div class="row nav-top auto">
                            <div class="col-2 xtl"><span class="nav-back wt"  @click="$router.go(-1)"></span></div>
                            <div class="col-8 tfw-5 tf-18">Income Details</div>
                            <div class="col-2"></div>
                            <div class="col-12 pt-2 pb-2 odtnav dflxsbt"><select class="odselect bgbp tfs-w" @change="comtab()"
                                    id="comtab" v-model="userdetails.level" >
                                    <option value="A">All income types</option>
                                    <option value="B">Withdraw</option>
                                    <option value="C">Order commission</option>
                                    <option value="D">Refer income</option>
                                </select></div>
                        </div>
                        <div class="row">
                            <div class="col-12 mt-4" id="dtaod">
                                <div class="row dflx pt-2 inbdb"  v-for="row in invite" :key="row.id">
                                    <div class="col-2 flh48"><span class="inliri tf-16 tfs-w xtc">Lv{{ getl(row.level) }}</span></div>
                                    <div class="col-6">
                                        <div class="row xtl">
                                            <div class="col-12 tfcdb tf-16">{{ gett(row.level) }}</div>
                                            <div class="col-6 tf-12 pt-1 cgray">{{settime(row.created_at)}}</div>
                                            <div class="col-6 tf-12 pt-1 cgray">from {{sub(row.giver)}}</div>
                                        </div>
                                    </div>
                                    <div class="col-4 pt-2 pr-4 xtr tfcdb tf-16">+{{row.amount}}</div>
                                </div>

                                <div id="norecord" class="mt-4 pt-4 tfcdg" style="display: none;">
                                    <div class="pt-3 tf-14">No records</div>
                                </div>
                                
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row" id="footer">
                    <div class="col-12 nav-bar" id="adsob">
                        <div class="row">
                            <div class="col-3 pa-0">
                                <div class="navItem" id="moxht2b4u" onclick="home()">
                                    <div class="xtc"><span class="icon home" id="home"></span></div>
                                    <div class="xtc">Home</div>
                                </div>
                            </div>
                            <div class="col-3 pa-0">
                                <div class="navItem sel" id="raeiyf2m0" onclick="group()">
                                    <div class="xtc"><span class="icon group" id="group"></span></div>
                                    <div class="xtc">Invite</div>
                                </div>
                            </div>
                            <div class="col-3 pa-0">
                                <div class="navItem" id="sfrm6bvy" onclick="wallet()">
                                    <div class="xtc"><span class="icon wallet" id="wallet"></span></div>
                                    <div class="xtc">Recharge</div>
                                </div>
                            </div>
                            <div class="col-3 pa-0">
                                <div class="navItem" id="mcpnvd2my" onclick="my()">
                                    <div class="xtc"><span class="icon my" id="my"></span></div>
                                    <div class="xtc">My</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row" id="opffp"></div>
                <div class="row" id="anof">
                </div>
                <div class="row" id="dta_ref"></div>
            </div>
        </div>
    </section>
</template>

<script>
import axios from "axios";
export default {
    name: "PromotionView",
    data() {
        return {
            userdetails: {
                level: 'A',
            },
            invite: {

            },
          
            info: {

            }

        }

    },
    mounted: function prepare() {
        this.getrecord();
    },
    methods: {
        comtab(){
            console.log(this.userdetails.level);
            this.getrecord();
        },
        getl(l){
            if(l==2){
                return '2';
            }else{
                return '1'; 
            }
        },
        gett(level){
            if(level==1){
                return 'Level-1 Commission';
            }else if(level==2){
                return 'Level-2 Commission';
            }else if(level==3){
                return 'Referral';
            }
        },
        sub(num){
            var sub=num;
            return "****"+sub.substring(7);
        },
        settime(time){
            var datetime = new Date(time);
            datetime.setHours(datetime.getHours() + 12)
        datetime.setMinutes(datetime.getMinutes() + 30)
        var time1= datetime.toLocaleString();
        var timeStamp=Date.parse(time1);
        const date= new Date(timeStamp);
        var dateFormat =  date.getDate()+
           "-"+(date.getMonth()+1)+" "+date.getHours()+":"+date.getMinutes();
        return dateFormat;
        },
        getrecord() {
            this.userdetails.username = localStorage.getItem('username');
            axios.get('https://fiewin.source-code.co.in/Gameapi/src/api/bet.php?action=invitereward&user=' + this.userdetails.username+"&level="+this.userdetails.level).then((res) => {
                this.invite = res.data;
                console.log(this.invite);
                if (this.invite.length ==0) {
                    document.getElementById("norecord").style.display = "";
                }else{
                    document.getElementById("norecord").style.display = "none";
                }
            }).catch((err) => {
                console.log(err);
            })
        },
    }
}

</script>
